var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWatermark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149.139 131.926V90.9537C158.398 90.9537 163.028 87.3889 163.028 80.2593C163.028 73.7315 159.509 70.4676 152.426 70.4676C145.296 70.4676 141.731 74.9352 141.731 83.8704V139.449C141.731 165.144 120.898 185.977 95.2036 185.977V88.662C95.2036 78.6157 96.2221 70.375 98.236 63.963C100.25 57.5509 103.699 51.5324 108.583 45.9769C114.069 39.8194 120.921 34.9352 129.139 31.3704C137.356 27.8056 145.852 26 154.625 26C170.458 26 183.768 31.3241 194.555 41.9954C205.343 52.6667 210.713 65.8843 210.713 81.625C210.713 96.9259 205.875 109.356 196.199 118.87C187.356 127.62 174.023 132.019 156.222 132.019L149.139 131.926Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8981 63.3379C59.9954 63.3379 39 84.3333 39 110.236V224.056C64.9028 224.056 85.8981 203.06 85.8981 177.157V63.3379Z",
    fill: "#C4C4C4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatermark);
export default __webpack_public_path__ + "static/media/Watermark.3115643f228f387ad344e8edbe921201.svg";
export { ForwardRef as ReactComponent };